/**
 * AsyncComponent
 * Code Splitting Component / Server Side Rendering
 */
import React from 'react';
import Loadable from 'react-loadable';

// rct page loader
import RctPageLoader from 'Components/RctPageLoader/RctPageLoader';

// ecommerce dashboard
const AsyncEcommerceDashboardComponent = Loadable({
	loader: () => import("Routes/dashboard/ecommerce"),
	loading: () => <RctPageLoader />,
});

// agency dashboard
const AsyncSaasDashboardComponent = Loadable({
	loader: () => import("Routes/dashboard/saas"),
	loading: () => <RctPageLoader />,
});

// agency dashboard
const AsyncAgencyDashboardComponent = Loadable({
	loader: () => import("Routes/dashboard/agency"),
	loading: () => <RctPageLoader />,
});

// boxed dashboard
const AsyncNewsDashboardComponent = Loadable({
	loader: () => import("Routes/dashboard/news"),
	loading: () => <RctPageLoader />,
});

const AsyncLiabilityTrackerComponent = Loadable({
	loader: () => import("Routes/dashboard/news/LiabilityTracker"),
	loading: () => <RctPageLoader />,
});

// crm dashboard
const AsyncCrmComponent = Loadable({
	loader: () => import("Routes/crm/dashboard"),
	loading: () => <RctPageLoader />,
});

const AsyncAnalysisDetailComponent = Loadable({
	loader: () => import("Routes/crm/dashboard/AnalysisDetail"),
	loading: () => <RctPageLoader />,
});

const AsyncLiveAnalysisDetailComponent = Loadable({
	loader:() => import("Routes/dashboard/ecommerce/LiveAnalysisDetail"),
	loading: () => <RctPageLoader />,
});

const AsyncLiveCompanyDetailsComponent = Loadable({
	loader:() => import("Routes/dashboard/agency/CompanyDetails"),
	loading: () => <RctPageLoader />,
});

const AsynQuickActions = Loadable({
	loader:() => import("Routes/dashboard/agency/QuickActionsContainer"),
	loading: () => <RctPageLoader />,
});

const AsynSubCompaniesManagement = Loadable({
	loader:() => import("Routes/dashboard/agency/SubCompaniesManagement"),
	loading: () => <RctPageLoader />,
});

const AsynUserProfile = Loadable({
	loader:() => import("Components/Sidebar/UserProfile"),
	loading: () => <RctPageLoader />,
});


const AsyncHrAnalyticsDashboardComponent = Loadable({
	loader:() => import("Routes/dashboard/hrAnalytics"),
	loading: () => <RctPageLoader />,
});

const AsyncAdminDashboardComponent = Loadable({
	loader:() => import("Routes/dashboard/admin/AdminDashboard"),
	loading: () => <RctPageLoader />,
});

const AsyncAdminSampleSheets = Loadable({
	loader:() => import("Routes/dashboard/admin/AdminSampleSheets"),
	loading: () => <RctPageLoader />,
});

const AsyncPlanBillingComponent = Loadable({
	loader: () => import("Routes/dashboard/agency/PlanBilling"),
	loading: () => <RctPageLoader />,
});





export {
	AsyncEcommerceDashboardComponent,
	AsyncSaasDashboardComponent,
	AsyncAgencyDashboardComponent,
	AsyncNewsDashboardComponent,
	AsyncCrmComponent,
	AsyncAnalysisDetailComponent,
	AsyncLiveAnalysisDetailComponent,
	AsyncLiveCompanyDetailsComponent,
	AsynQuickActions,
	AsynSubCompaniesManagement,
	AsynUserProfile,
	AsyncLiabilityTrackerComponent,
	AsyncAdminDashboardComponent,
	AsyncHrAnalyticsDashboardComponent,
	AsyncAdminSampleSheets,
	AsyncPlanBillingComponent
};
